import { render, staticRenderFns } from "./JobDetailPreview.vue?vue&type=template&id=66124282&scoped=true"
import script from "./JobDetailPreview.vue?vue&type=script&lang=js"
export * from "./JobDetailPreview.vue?vue&type=script&lang=js"
import style0 from "./JobDetailPreview.vue?vue&type=style&index=0&id=66124282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66124282",
  null
  
)

export default component.exports